/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import React from 'react'

interface PropsType {
	src: string
	style?: React.CSSProperties
	className?: string
	onLoad?: (e: any) => void
}

export const ImageComponent = styled.img({}, (props: PropsType) => {
	return { ...props.style }
})

export const Image = (props: PropsType) => {
	return (
		<ImageComponent
			className={props.className}
			src={props.src}
			style={{ ...props.style }}
			onLoad={(e: any) => {
				if (typeof props.onLoad === 'function') {
					props.onLoad(e)
				}
			}}
		/>
	)
}
